import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { searchDish, saveSearchParam } from '../../../actions/dishSearch';

class SearchBar extends Component {
  state = {
    // eslint-disable-next-line react/no-unused-state
    searching: false,
  };

  handleClick = (value) => {
    const { saveSearchParam, searchDish } = this.props;
    saveSearchParam(value);
    searchDish(value, true);
  };

  handleChange = (event) => {
    const { saveSearchParam } = this.props;
    saveSearchParam(event.target.value);
  };

  handleSubmit = (event) => {
    const { searchDish, searchParam } = this.props;
    event.preventDefault();
    searchDish(searchParam, true);
  };

  render() {
    const { searchParam } = this.props;
    return (
      <SearchRow>
        <Form>
          <Input
            name="search"
            autoComplete="off"
            placeholder="Поиск блюда"
            value={searchParam}
            onChange={this.handleChange}
          />
          <Submit onClick={this.handleSubmit}>поиск</Submit>
        </Form>
      </SearchRow>
    );
  }
}

const mapStateToProps = (state) => {
  const { searchParam, filterParam, sortParam } = state.searchParams;
  return {
    searchParam,
    filterParam,
    sortParam,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchDish: (value, rendering) => {
      dispatch(searchDish(value, rendering));
    },
    saveSearchParam: (searchParam) => {
      dispatch(saveSearchParam(searchParam));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);

const SearchRow = styled.div`
  width: 80%;
  height: 40px;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
`;

const Form = styled.form`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const Input = styled.input`
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 16px;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  @media (max-width: 768px) {
    width: 70%;
  }
`;

const Submit = styled.button`
  width: 100px;
  height: 100%;
  margin-left: 15px;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  background: #157aac;
  color: #fff;
  border: none;
  border-radius: 5px;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
  @media (max-width: 768px) {
    margin-left: 0;
    width: 25%;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/SearchBar/SearchBar.jsx